import React from 'react';

const TalibeCheikhSupport = () => {
    return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>Talibé Cheikh Pro – Support</h1>
        <p style={styles.subtitle}>
          Nous sommes là pour vous aider. Pour toute question, problème
          technique ou suggestion, contactez-nous via les informations
          ci-dessous.
        </p>

        <div style={styles.grid}>
          <div style={styles.card}>
            <h2 style={styles.cardTitle}>📧 Support Email</h2>
            <p style={styles.text}>
              Envoyez-nous un email et nous vous répondrons dès que possible.
            </p>
            <a
              href="mailto:dmflthiaroye@gmail.com"
              style={styles.button}
            >
              dmflthiaroye@gmail.com
            </a>
          </div>

          {/* <div style={styles.card}>
            <h2 style={styles.cardTitle}>❓ Questions fréquentes</h2>
            <ul style={styles.list}>
              <li>Comment restaurer mes achats ?</li>
              <li>Pourquoi les publicités ne s'affichent pas ?</li>
              <li>Comment signaler une erreur dans le contenu ?</li>
              <li>Comment proposer une amélioration ?</li>
            </ul>
          </div> */}

          <div style={styles.card}>
            <h2 style={styles.cardTitle}>📱 Informations sur l’application</h2>
            <p style={styles.text}>
              Nom : Talibé Cheikh Pro
              <br />
              Version : 1.7.0
              <br />
              Plateformes : iOS, Android
            </p>
          </div>

          <div style={styles.card}>
            <h2 style={styles.cardTitle}>🔒 Confidentialité</h2>
            <p style={styles.text}>
              Nous respectons votre vie privée. Pour toute question concernant
              vos données personnelles, contactez-nous directement par email.
            </p>
          </div>
        </div>

        <footer style={styles.footer}>
          © {new Date().getFullYear()} Talibé Cheikh Pro. Tous droits réservés.
        </footer>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#f4f6f9",
    display: "flex",
    justifyContent: "center",
    padding: "40px 20px",
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
  },
  container: {
    maxWidth: "900px",
    width: "100%",
  },
  title: {
    fontSize: "36px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "10px",
  },
  subtitle: {
    textAlign: "center",
    color: "#555",
    marginBottom: "40px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "20px",
  },
  card: {
    backgroundColor: "#ffffff",
    padding: "25px",
    borderRadius: "16px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
  },
  cardTitle: {
    fontSize: "20px",
    marginBottom: "10px",
  },
  text: {
    color: "#555",
    marginBottom: "15px",
    lineHeight: "1.6",
  },
  list: {
    paddingLeft: "18px",
    color: "#555",
    lineHeight: "1.8",
  },
  button: {
    display: "inline-block",
    padding: "10px 18px",
    backgroundColor: "#007AFF",
    color: "#ffffff",
    borderRadius: "12px",
    textDecoration: "none",
    fontWeight: "600",
  },
  footer: {
    marginTop: "50px",
    textAlign: "center",
    fontSize: "14px",
    color: "#888",
  },
};

export default TalibeCheikhSupport;